class LoaderCtrl {
  noteIsSplit = false;
  note0 = "";
  note1 = "";

  constructor() {}

  // $onChanges (not $onInit) so the note stays in sync when the parent updates it (e.g. Submitting -> Redirecting).
  $onChanges(changes) {
    if (changes.note) this.splitNote();
  }

  splitNote() {
    this.noteIsSplit = !!this.note && this.note.split(' ').length > 1;
    [this.note0, this.note1] = this.noteIsSplit ? this.note.split(' ') : ["", ""];
  }
}

export default {
  bindings: {note: '<'},
  templateUrl: 'layout/loader/loader.component.html',
  controller: LoaderCtrl
}
